import styles from './styles.module.css'
import {
  DataGrid
} from '../../widgets/data-grid'
import { useCallback, useEffect, useState } from 'react'
import { type TPlayer } from './types'
import { useNavigate } from 'react-router-dom'
import { mapDispatchToProps, mapStateToProps } from './maps'
import { connect, useSelector } from 'react-redux'
import { IconMenu } from '../../widgets/icon-menu'
import { SearchPanel } from '../../widgets/search-bar/SearchPanel'
import { type TSearchQuery } from '../../widgets/search-bar/types'
import { RootState } from '../../app/store'
import { EColumnType, TColumns } from '../../widgets/data-grid/types'
import { searchFilter } from '../../widgets/search-bar/search-service'
import { columns } from './maps';
import { OperatorManipulationService, TOperator } from '../../shared/operator/operator-manipulation-service/operator-manipulation-service'
import { loadOperatorsList } from 'app/store/sagas/root'



const operatorManipulationService = OperatorManipulationService()

export const OperatoresListPage: any = connect(mapStateToProps, mapDispatchToProps)(function ({
  count,
  operators,
  setSelectedOperators,
}: any) {
  const [searchQuery, setSearchQuery] = useState<TSearchQuery[]>([])
  const roleOperator = useSelector((state: RootState) => state.loginSlice.role)
  const navigate = useNavigate()

  if (roleOperator !== 'administrator') {
    setTimeout(() => navigate('/'))
    return <></>
  }

  useEffect(() => {
    // loadOperatorsList()
  }, [])

  /**
   * TODO: Edit operator
   * TODO: Remove operator
   */

  const onSearchQueryChange = useCallback((query: TSearchQuery[]) => {
    setSearchQuery(query)
  }, [])

  const onSelectionChange = (selection: string[]) => setSelectedOperators(operators?.filter((operator: TOperator) => selection.includes(operator.id)) || [])

  const nextRows = async (page: number, perPageCount: number) => {
    return (await operatorManipulationService.getOperatores(page, perPageCount))?.operators
  }

  return <div className={styles.PlayerPage}>
        {/* <AdminMenu /> */}
        <div className={styles.ListContainer}>
            <div className={styles.TableContainer}>
                <IconMenu
                    onCreateClick={() => { navigate('/operatores/create') }}
                />
                <SearchPanel
                    columns={columns}
                    onQueryChange={onSearchQueryChange}
                />
                {<DataGrid
                    nextRows={nextRows}
                    count={count}
                    className={styles.DataGrid}
                    rows={searchFilter(operators, searchQuery)}
                    columns={columns}
                    onSelectionChange={onSelectionChange}
                    controls={true}
                    editable={false}
                /> }
            </div>
        </div>

    </div>
})
